import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../models/State"
import {setFilterClearAllAction, setFacet} from "../../ducks/search"
import {isFilterFacet} from "../../models/Filter/typeGuards"
import {getFacetsWithUnselectedOption, getFilteredFacetList, getRefinedFilters} from "../../utils/getFilterFacets"
import TrackFilterClearAll from "../../events/trackEvent/events/trackFilterClearAll"
import {FacetState} from "../../models/FacetsState"
import {LINK} from "../../config/constants"

const selectFacets = (state: State) => state.search.facets
const selectFilters = (state: State) => state.search.filters
const selectFiltersSort = (state: State) => state.search.filtersSort
const selectSingleOptionFacetList = (state: State) => state.search.singleOptionFacetList

export const selectConsolidatedPrimarySecondaryFacets = createSelector(
    [selectFacets, selectFilters, selectFiltersSort, selectSingleOptionFacetList],
    (facets, filters, filtersSort, singleOptionFacetList) => {
        const filteredFacets: Record<string, string[]> = {}
        // TODO: next two statements are ignored (POC only)
        // Look for facets that are link facets to avoid showing them as filters
        const linkFacets: FacetState[] = Object.keys(facets)
            .filter(facetName => facetName.startsWith(`${LINK}:`))
            .map(facetName => facets[facetName])

        const consolidatedFacets: string[] = []

        Object.entries(filters).forEach(([_key, value]) => {
            if (isFilterFacet(value)) {
                const filteredFacetList = getFilteredFacetList(value, facets)
                if (filteredFacetList.length > 0) filteredFacets[value.displayName] = filteredFacetList
                if (getFacetsWithUnselectedOption(value, facets)) {
                    consolidatedFacets.push(value.name)
                }
            }
        })

        let consolidatedFilters = getRefinedFilters(filtersSort, filters, singleOptionFacetList, consolidatedFacets)
        const isFilterSelected: boolean = Object.keys(filteredFacets).length > 0

        // Remove link filter type from consolidated filters to avoid displaying them as filters
        if (linkFacets.length > 0) {
            consolidatedFilters = consolidatedFilters.filter(filter => filter !== LINK)
        }

        const featFacets: FacetState[] = Object.keys(facets)
            .filter(facetName => facetName.startsWith("feat:"))
            .map(facetName => facets[facetName])

        const primaryFeatFacets = featFacets.slice(0, 2)

        return {
            isFilterSelected,
            consolidatedFilters,
            primaryFeatFacets,
            secondaryFeatFacets: featFacets.slice(primaryFeatFacets.length, featFacets.length) || [],
        }
    },
)

export const mapStateToProps = (state: State) => {
    const {totalResults, filters, initialScrollCompleted, rememberFilters, disableIcons, breadcrumbs} = state.search
    const {
        template,
        request: {url},
    } = state

    const {isFilterSelected, consolidatedFilters, primaryFeatFacets, secondaryFeatFacets} =
        selectConsolidatedPrimarySecondaryFacets(state)

    const {text} = state
    return {
        totalResults,
        filters,
        text,
        initialScrollCompleted,
        templating: template,
        url,
        rememberFilters,
        breadcrumbs,
        disableIcon: disableIcons.moreLess,
        isFilterSelected,
        consolidatedFilters,
        primaryFeatFacets,
        secondaryFeatFacets,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    clearAllFilters: () => {
        TrackFilterClearAll()
        dispatch(setFilterClearAllAction())
    },
    handleSetFacet: (facetValue: string): void => {
        dispatch(setFacet(facetValue))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
